module.exports = __webpack_public_path__ + "static/media/Woman-with-pearl-collar-408280-min.86768dff.jpg";